import React, { useEffect } from "react";
import { useRemoteComponent } from "@bookingcom/remote-component";
import useEvents from "../../hooks/useEvents.js";
import useUserAgent from "../../hooks/useUserAgent.js";
import Container from "../elements/Container/index.js";
import Frame from "../elements/Frame/index.js";
const AppleCardIndex = () => {
    const { grumble } = useEvents();
    const { isMobile } = useUserAgent();
    const { Component, error } = useRemoteComponent({
        project: "web-shell",
        service: "header-mfe",
        path: "/PromotionalBanner/Flights/Index",
        type: "capla"
    });
    useEffect(() => {
        if (error) {
            grumble("Remote component error: Apple card on Index page", { error });
        }
    }, [error, grumble]);
    return isMobile ? (React.createElement(Frame, { attributes: { style: { width: "100%" } }, p: 4, mt: 2, mb: 2 },
        React.createElement(Component, null))) : (React.createElement(Container, { pt: 6 },
        React.createElement(Component, null)));
};
export default AppleCardIndex;
